<script setup lang="ts">
import { onMounted, ref } from 'vue';
import UserFooter from './parts/UserFooter.vue';
import UserHeader from './parts/UserHeader.vue';
import backgroundImage from '@/assets/images/white_pattern.jpg';
const backgroundStyle = {
  backgroundImage: `url(${backgroundImage})`
};
const bubbles = ref<Array<{ size: number; left: number }>>([]);

onMounted(() => {
  createBubbles();
});

const getBubbleStyle = (bubble: { size: number; left: number }) => {
  return {
    width: `${bubble.size}px`,
    height: `${bubble.size}px`,
    left: `${bubble.left}%`,
    animationDuration: `${Math.random() * 5 + 5}s` // Durasi acak untuk setiap gelembung
  };
};

const createBubbles = () => {
  const totalBubbles = 20;
  for (let i = 0; i < totalBubbles; i++) {
    bubbles.value.push({
      size: Math.random() * 100 + 10, // Ukuran acak antara 10px dan 60px
      left: Math.random() * 100 // Posisi acak di layar
    });
  }
};
</script>
<template>
  <div class="w-full h-screen bg-cover overflow-y-auto overflow-x-hidden" :style="backgroundStyle">
    <div
      class="bg-gradient-to-br from-cyan-500 to-fuchsia-500 dark:from-cyan-900 dark:to-fuchsia-900 absolute top-0 left-0 w-full h-full bg-no-repeat bg-cover bg-center z-0 opacity-[87%]"
    ></div>
    <div class="bubble-container">
      <div
        v-for="(bubble, index) in bubbles"
        :key="index"
        class="bubble"
        :style="getBubbleStyle(bubble)"
      ></div>
    </div>
    <div class="main relative flex flex-col justify-between max-w-5xl mx-auto h-screen">
      <UserHeader />
      <div class="h-full px-4 py-6 pb-16">
        <slot />
      </div>
      <UserFooter />
    </div>
  </div>
</template>

<style scoped>
.with-blur-backdrop {
  background-color: rgba(0, 0, 0, 0.397);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  padding: 20px 30px;
}

.bubble-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  @apply dark:bg-black dark:opacity-60;
}

.bubble {
  position: absolute;
  bottom: -60px;
  /* Mulai di bawah layar */
  background-color: rgb(255, 255, 255);
  border-radius: 50%;
  animation: floatUp ease-in infinite;

  @apply opacity-5 dark:opacity-[0.02];
}

@keyframes floatUp {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-100vh);
    /* Gelembung akan naik sepanjang layar */
  }
}
</style>
